// extracted by mini-css-extract-plugin
export default {"notBox":"NotFound_notBox__RWf8B"};